import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Tabs,
  Tab,
  Box,
  CircularProgress,
  Typography,
  Grid,
  Avatar,
} from "@mui/material";
import CropLevelData from "./CropLevelData";
import { CMS_maati } from "urlconfig";

export const FgdLevelTab = ({ selectedFarmer, documentId }) => {
  const [uiSchemas, setUiSchemas] = useState({});
  const [loadingSchema, setLoadingSchema] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  // console.log("selectedFarmer",selectedFarmer)
  // console.log("uiSchemas",uiSchemas)
  const fetchSchemas = async () => {
    try {
      const res = await axios.get(`${CMS_maati}/api/ui-schemas?filters[language][$eq]=en`);
      const schemaMap = {};
      (res.data?.data || []).forEach((item) => {
        schemaMap[item.form_name] = item.labels?.form_data?.components || [];
      });
      setUiSchemas(schemaMap);
    } catch (err) {
      console.error("UI Schema error:", err);
    } finally {
      setLoadingSchema(false);
    }
  };

  useEffect(() => {
    fetchSchemas();
  }, []);

  const tabs = [
        { label: "Crop Level", key: "fgd_crop", schema: "fgd_crop" ,icon:"https://agrani-cms.leadsconnect.in/uploads/wheat_d30c344152.png"},
    { label: "Economic", key: "fgd_economic", schema: "fgd_economic",icon:"https://agrani-cms.leadsconnect.in/uploads/indian_rupee_f4ec046d76.png" },
    { label: "Governance", key: "fgd_governance", schema: "fgd_governance",icon:"https://agrani-cms.leadsconnect.in/uploads/policy_159ac6b85e.png" },
    { label: "Social", key: "fgd_social", schema: "fgd_social" ,icon:"https://agrani-cms.leadsconnect.in/uploads/group_cd2f5a1033.png"},
    { label: "Skill", key: "fgd_skill", schema: "fgd_skill",icon:"https://agrani-cms.leadsconnect.in/uploads/skill_782986c8c3.png" },
  ];

  const humanize = (key = "") =>
    key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase())
      .trim();

  const hasRenderableValue = (v) => {
    if (v === undefined || v === null) return false;
    if (typeof v === "string" && v.trim() === "") return false;
    if (Array.isArray(v) && v.length === 0) return false;
    return true;
  };

  const renderValue = (value) => {
    if (!hasRenderableValue(value)) return null;
    if (Array.isArray(value)) return value.join(", ");
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  };
//   const renderValue = (value) => {
//   if (value === undefined || value === null) return "-";
//   if (typeof value === "string" && value.trim() === "") return "-";
//   if (Array.isArray(value) && value.length === 0) return "-";
//   if (typeof value === "object") return JSON.stringify(value);
//   return String(value);
// };


  const renderDynamicData = (farmerData = {}, schemaArray = []) => {
    // console.log("render",farmerData,"----",schemaArray)
    if (!farmerData || Object.keys(farmerData).length === 0) {
      return (
        <Box sx={{ p: 2 }}>
          <Typography color="text.secondary">No data available</Typography>
        </Box>
      );
    }

    const schemaKeys = schemaArray.map((f) => f.key);
    const schemaLabelMap = {};
    schemaArray.forEach((f) => {
      if (f?.key) schemaLabelMap[f.key] = f.label || humanize(f.key);
    });

    const orderedFields = [];

    schemaKeys.forEach((k) => {
      if (farmerData.hasOwnProperty(k) && hasRenderableValue(farmerData[k])) {
        orderedFields.push({
          key: k,
          label: schemaLabelMap[k],
          value: farmerData[k],
        });
      }
    });

    Object.keys(farmerData).forEach((k) => {
      if (!schemaKeys.includes(k) && hasRenderableValue(farmerData[k])) {
        orderedFields.push({ key: k, label: humanize(k), value: farmerData[k] });
      }
    });

    return (
     <div className=" my-3">
      <div className="row g-3">
          {orderedFields.map((f,key) => (
           <div className="col-md-6 col-lg-4" key={key}>
              <div className="border rounded-3 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-start ">
                  <i className="mdi mdi-chevron-double-right text-success me-2 fs-5"></i>
                  <span className="fw-semibold text-dark mt-1">
                    {f.label}
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  <i className="mdi mdi-chevron-right me-2 fs-5"></i>
                  <span className="text-gray">{renderValue(f.value)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> 
    );
  };

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  const farmerObjectForTab = (tabKey) => {
    if (!selectedFarmer) return null;
    return selectedFarmer[tabKey] ?? null;
  };

  return (
    <Box>
      {loadingSchema ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
            indicatorColor="primary"
            sx={{ borderBottom: "1px solid #eee" }}
          >
          
              {tabs.map((tab) => (
                    <Tab
                      key={tab.id}
                      label={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Avatar
                            src={tab.icon}
                            alt={tab.label}
                            sx={{ width: 28, height: 28 }}
                          />
                          <Typography
                            variant="body2"
                            fontWeight={600}
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {tab.label}
                          </Typography>
                        </Box>
                      }
                    />
                  ))}
          </Tabs>
          
          <Box sx={{ p: 2 }}>
            {renderDynamicData(
              farmerObjectForTab(tabs[selectedTab].key),
              uiSchemas[tabs[selectedTab].schema] || []
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
